export default "__VITE_ASSET__cc56f986__"